import { CloseOutlined } from "@ant-design/icons";
import { Button, Popover, Tooltip, message } from "antd";
import { Style } from "./style";
import { useNewItem } from "./hook";
import { showHideInput } from "../../../../../../../components/DynamicViewNew/helper";
import { ProjectService } from "../../../../../../../services";
import i18next from "i18next";

export default function NewItem({
  onConfirm = () => { },
  onClose = () => { },
  inputs = {},
  preSelected = [],
  group,
}) {
  const isSource = group === 'informationSources';

  const {
    t,
    data,
    visible,
    setVisible,
    renderInput,
    removeContent,
    disabled,
  } = useNewItem({ onClose, inputs, isSource });

  const onSubmit = async () => {
    try {
      const res = await ProjectService.checkUser({ ...data, preSelected });
      if (res.data) {
        if (preSelected.find((p) => p === res.data.id)) {
          message.error(i18next.t('This user is already part of this project'));
        } else {
          onConfirm(res.data, { ...data, authorId: res.data.id });
        }
      }
    } catch (err) {
      message.error(i18next.t(typeof err === 'string' ? err : 'No user corresponding to this ID'));
    }
  };

  const _renderInputs = () => Object.keys(inputs)
    .sort((a, b) => inputs[a].position - inputs[b].position)
    .filter((key) => {
      if (inputs[key].showIf) {
        return showHideInput(inputs[key], data)
      }
      return true;
    })
    .map((key) => {
      const conf = inputs[key];

      return (
        <div className="row-item" key={`form-${key}`}>
          <label>{conf.label || ''}</label>
          <div className="input">
            {renderInput(conf, key)}
          </div>
        </div>
      );
    });

  return (
    <Style>
      <div className="header-cont">
        <div className="left">
          <h4>
            {t(isSource ? 'New Information Source' : 'New Client')}
          </h4>
        </div>
        <div className="right">
          <Popover content={removeContent} placement="left" visible={visible}>
            <Button icon={<CloseOutlined />} onClick={() => setVisible(true)} size="small" />
          </Popover>
        </div>
      </div>

      <div className="form">
        {_renderInputs()}
        {!!disabled ? (
          <Tooltip title={t(disabled)}>
            <Button type="primary" onClick={onSubmit} disabled>
              {t('Confirm')}
            </Button>
          </Tooltip>
        ) : (
          <Button type="primary" onClick={onSubmit}>
            {t('Confirm')}
          </Button>
        )}
      </div>
    </Style >
  );
}
